import * as classNames from "classNames";
import * as React from "react";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { Lightbox, LightboxType } from "../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { NumberTextBoxEditor } from "../../../../../react-core/Html/NumberTextBoxEditor";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { PercentageTextBoxEditor } from "../../../../../react-core/Html/PercentageTextBoxEditor";
import { RadiosEditor } from "../../../../../react-core/Html/RadiosEditor";
import { TextBoxEditor } from "../../../../../react-core/Html/TextBoxEditor";
import { PensionProtectionDetails } from "../../../../../Wrap/Models/Models/Customer/PensionProtection/PensionProtectionDetails";
import { ClientRecordAction } from "./Action/ClientRecordAction";
import {
    ClientRecordTab,
    GrantedTypes,
    GrantedTypesMap,
    IClientTabProps,
    PensionProtectionMap,
} from "./Resource/Contents";
import { ClientRecordStore } from "./Store/Variable";

interface IPensionProtectionState {
    PensionProtection: PensionProtectionDetails;
    _data: PensionProtectionDetails;
    isLoading: boolean;
    errorMsg: string[];
}

interface IPensionProtectionProps extends IClientTabProps {
    callback?: () => void;
    hideHeading?: boolean;
    hideContainerClasses?: boolean;
    onSaveBack?: (result) => void;
}

export class PensionProtection extends FormComponent<IPensionProtectionProps, IPensionProtectionState> {
    constructor(props: IPensionProtectionProps) {
        super(props);
        this.state = {
            PensionProtection: null,
            _data: null,
            isLoading: true,
            errorMsg: [],
        };
        this.subscribeToStore(ClientRecordStore, () => this.onClientRecordStoreChange());
    }

    private onClientRecordStoreChange() {
        const data = ClientRecordStore.getData();
        this.setState({
            isLoading: false,
            PensionProtection: data[ClientRecordTab.PensionProtection],
            _data: JSON.parse(JSON.stringify(data[ClientRecordTab.PensionProtection])),
        });
    }

    private onSave() {
        const { PensionProtection } = this.state;
        if (super.isValid()) {
            this.setState({ isLoading: true });
            ClientRecordAction.savePensionProtection(Number(this.props.id), PensionProtection, (result) => {
                if (result.length == 0) {
                    this.state.errorMsg.push("The information has been saved successfully.");
                    if (this.props.onSaveBack) {this.props.onSaveBack(PensionProtection);}
                } else {
                    this.setState({ errorMsg: result });
                }
                ClientRecordAction.getPensionProtection(Number(this.props.id));
            });
        }
    }

    private grantSelected(key: string): string {
        const { PensionProtection } = this.state;
        const _data = PensionProtection[key];
        let flag = null;
        GrantedTypes.forEach((ele) => {
            if (_data[ele]) {flag = ele;}
        });
        return flag;
    }

    private dataOnchanged(key: string, value: any, entity: string) {
        const { PensionProtection, _data } = this.state;
        _data[key][entity] = value;
        PensionProtection[key][entity] = _data[key][entity];
        this.setState({ PensionProtection });
    }

    private redioDisable(key: string): boolean {
        const { PensionProtection } = this.state;
        switch (key) {
            case "PensionEnhancedProtectionDetails":
                return (
                    PensionProtection.PensionFixedProtectionDetails != null ||
                    PensionProtection.PensionFixed2014ProtectionDetails != null ||
                    PensionProtection.PensionFixed2016ProtectionDetails != null
                );
            case "PensionPrimaryProtectionDetails":
                return (
                    PensionProtection.PensionFixedProtectionDetails != null ||
                    PensionProtection.PensionFixed2014ProtectionDetails != null ||
                    PensionProtection.PensionFixed2016ProtectionDetails != null ||
                    PensionProtection.PensionIndividual2014ProtectionDetails != null ||
                    PensionProtection.PensionIndividual2016ProtectionDetails != null
                );
            case "PensionFixedProtectionDetails":
                return (
                    PensionProtection.PensionFixed2014ProtectionDetails != null ||
                    PensionProtection.PensionFixed2016ProtectionDetails != null
                );
            case "PensionFixed2014ProtectionDetails":
                return (
                    PensionProtection.PensionFixedProtectionDetails != null ||
                    PensionProtection.PensionFixed2016ProtectionDetails != null
                );
            case "PensionFixed2016ProtectionDetails":
                return (
                    PensionProtection.PensionFixed2014ProtectionDetails != null ||
                    PensionProtection.PensionFixedProtectionDetails != null
                );
            case "PensionIndividual2014ProtectionDetails":
                return PensionProtection.PensionIndividual2016ProtectionDetails != null;
            case "PensionIndividual2016ProtectionDetails":
                return PensionProtection.PensionIndividual2014ProtectionDetails != null;
        }
        return false;
    }

    componentDidMount() {
        ClientRecordAction.getPensionProtection(Number(this.props.id));
    }

    render() {
        if (this.state.isLoading) {return <PartLoading isLoading={true} />;}

        const { PensionProtection, _data, errorMsg } = this.state;
        const { callback } = this.props;
        const radioOptions = {
            cssWrapper: "rg-150 mb-16",
            options: [true, false],
            getText: (v) => (v ? "Yes" : "No"),
        };
        return (
            <div className={classNames({ "panel-subtle pl-34 pt-38": !this.props.hideContainerClasses })}>
                {!this.props.hideHeading && <h3>Pension protection</h3>}

                {errorMsg.length > 0 && (
                    <Lightbox
                        show={this.state.errorMsg.length > 0}
                        title={"Success"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ errorMsg: [] })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        {this.state.errorMsg.map((error, index) => {
                            return <p key={`error-${index}`}>{error}</p>;
                        })}
                        <button
                            className="btn primary"
                            onClick={() => {
                                this.setState({ errorMsg: [] });
                                if (callback) {callback();}
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
                {PensionProtectionMap.map((e) => {
                    let child;
                    if (PensionProtection[e.key] != null) {
                        switch (e.key) {
                            case "PensionEnhancedProtectionDetails":
                                child = (
                                    <>
                                        <PercentageTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="PCLS entitlement (%)"
                                            atMost={{
                                                errorMessage: "At most 100",
                                                value: 100,
                                            }}
                                            atLeast={{
                                                errorMessage: "At least 0",
                                                value: 0,
                                            }}
                                            value={_data.PensionEnhancedProtectionDetails.PclsEntitlement}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionEnhancedProtectionDetails",
                                                    v,
                                                    "PclsEntitlement"
                                                );
                                            }}
                                            onBlur={(v) => {
                                                this.dataOnchanged(
                                                    "PensionEnhancedProtectionDetails",
                                                    Number(CommonHelper.downFixed(v, 2)),
                                                    "PclsEntitlement"
                                                );
                                            }}
                                        />
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Certificate number"
                                            maxLength={10}
                                            value={_data.PensionEnhancedProtectionDetails.CertificateNumber}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionEnhancedProtectionDetails",
                                                    v,
                                                    "CertificateNumber"
                                                );
                                            }}
                                        />
                                    </>
                                );
                                break;
                            case "PensionPrimaryProtectionDetails":
                                child = (
                                    <>
                                        <NumberTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="PCLS entitlement (£)"
                                            maxLength={15}
                                            value={_data.PensionPrimaryProtectionDetails.PclsEntitlement}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionPrimaryProtectionDetails",
                                                    v,
                                                    "PclsEntitlement"
                                                );
                                            }}
                                            onBlur={(v) => {
                                                this.dataOnchanged(
                                                    "PensionPrimaryProtectionDetails",
                                                    Number(CommonHelper.downFixed(v, 2)),
                                                    "PclsEntitlement"
                                                );
                                            }}
                                        />
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Certificate number"
                                            maxLength={10}
                                            value={_data.PensionPrimaryProtectionDetails.CertificateNumber}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionPrimaryProtectionDetails",
                                                    v,
                                                    "CertificateNumber"
                                                );
                                            }}
                                        />
                                        <NumberTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Enhancement factor number"
                                            maxLength={15}
                                            validationRules={[
                                                {
                                                    errorMessage: "Please enter Enhancement factor number",
                                                    validator: (v) => {
                                                        return !!_data.PensionPrimaryProtectionDetails
                                                            .EnhancementFactor;
                                                    },
                                                },
                                            ]}
                                            value={_data.PensionPrimaryProtectionDetails.EnhancementFactor}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionPrimaryProtectionDetails",
                                                    v,
                                                    "EnhancementFactor"
                                                );
                                            }}
                                            onBlur={(v) => {
                                                this.dataOnchanged(
                                                    "PensionPrimaryProtectionDetails",
                                                    Number(CommonHelper.downFixed(v, 2)),
                                                    "EnhancementFactor"
                                                );
                                            }}
                                        />
                                    </>
                                );
                                break;
                            case "PensionFixedProtectionDetails":
                                child = (
                                    <>
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Certificate number (Fixed protection 2012)"
                                            maxLength={10}
                                            value={_data.PensionFixedProtectionDetails.CertificateNumber}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionFixedProtectionDetails",
                                                    v,
                                                    "CertificateNumber"
                                                );
                                            }}
                                        />
                                    </>
                                );
                                break;
                            case "PensionFixed2014ProtectionDetails":
                                child = (
                                    <>
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Certificate number (Fixed protection 2014)"
                                            maxLength={10}
                                            value={_data.PensionFixed2014ProtectionDetails.CertificateNumber}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionFixed2014ProtectionDetails",
                                                    v,
                                                    "CertificateNumber"
                                                );
                                            }}
                                        />
                                    </>
                                );
                                break;
                            case "PensionFixed2016ProtectionDetails":
                                child = (
                                    <>
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Certificate number (Fixed protection 2016)"
                                            maxLength={10}
                                            value={_data.PensionFixed2016ProtectionDetails.CertificateNumber}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionFixed2016ProtectionDetails",
                                                    v,
                                                    "CertificateNumber"
                                                );
                                            }}
                                        />
                                    </>
                                );
                                break;
                            case "PensionIndividual2014ProtectionDetails":
                                child = (
                                    <>
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Certificate number (Individual protection 2014)"
                                            maxLength={10}
                                            value={_data.PensionIndividual2014ProtectionDetails.CertificateNumber}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionIndividual2014ProtectionDetails",
                                                    v,
                                                    "CertificateNumber"
                                                );
                                            }}
                                        />
                                        <NumberTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Individual Protection 2014 LTA amount"
                                            required="Please enter Individual Protection 2014 LTA amount"
                                            atMost={{
                                                errorMessage: "A value between 1250000 and 1500000 is expected.",
                                                value: 1500000,
                                            }}
                                            atLeast={{
                                                errorMessage: "A value between 1250000 and 1500000 is expected.",
                                                value: 1250000,
                                            }}
                                            value={_data.PensionIndividual2014ProtectionDetails.Amount}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionIndividual2014ProtectionDetails",
                                                    v,
                                                    "Amount"
                                                );
                                            }}
                                            onBlur={(v) => {
                                                this.dataOnchanged(
                                                    "PensionIndividual2014ProtectionDetails",
                                                    Number(CommonHelper.downFixed(v, 2)),
                                                    "Amount"
                                                );
                                            }}
                                        />
                                    </>
                                );
                                break;
                            case "PensionIndividual2016ProtectionDetails":
                                child = (
                                    <>
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Certificate number (Individual protection 2016)"
                                            maxLength={10}
                                            value={_data.PensionIndividual2016ProtectionDetails.CertificateNumber}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionIndividual2016ProtectionDetails",
                                                    v,
                                                    "CertificateNumber"
                                                );
                                            }}
                                        />
                                        <NumberTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Individual Protection 2016 LTA amount"
                                            required="Please enter Individual Protection 2016 LTA amount"
                                            atMost={{
                                                errorMessage: "A value between 1000000 and 1250000 is expected.",
                                                value: 1250000,
                                            }}
                                            atLeast={{
                                                errorMessage: "A value between 1000000 and 1250000 is expected.",
                                                value: 1000000,
                                            }}
                                            value={_data.PensionIndividual2016ProtectionDetails.Amount}
                                            onChange={(v) => {
                                                this.dataOnchanged(
                                                    "PensionIndividual2016ProtectionDetails",
                                                    v,
                                                    "Amount"
                                                );
                                            }}
                                            onBlur={(v) => {
                                                this.dataOnchanged(
                                                    "PensionIndividual2016ProtectionDetails",
                                                    Number(CommonHelper.downFixed(v, 2)),
                                                    "Amount"
                                                );
                                            }}
                                        />
                                    </>
                                );
                                break;
                            case "PensionRelevantOverseasProtectionDetails":
                            case "PensionQropsProtectionDetails":
                            case "PensionCreditProtectionDetails":
                                child = (
                                    <>
                                        <TextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Certificate number"
                                            maxLength={10}
                                            value={_data[e.key].CertificateNumber}
                                            onChange={(v) => {
                                                PensionProtection[e.key].CertificateNumber = v;
                                                this.setState({ PensionProtection });
                                            }}
                                        />
                                        <NumberTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Enhancement factor number"
                                            validationRules={[
                                                {
                                                    errorMessage: "Please enter Enhancement factor number",
                                                    validator: (v) => {
                                                        return !!_data[e.key].EnhancementFactor;
                                                    },
                                                },
                                            ]}
                                            maxLength={15}
                                            value={PensionProtection[e.key].EnhancementFactor}
                                            onChange={(v) => {
                                                this.dataOnchanged(e.key, v, "EnhancementFactor");
                                            }}
                                            onBlur={(v) => {
                                                this.dataOnchanged(
                                                    e.key,
                                                    Number(CommonHelper.downFixed(v, 2)),
                                                    "EnhancementFactor"
                                                );
                                            }}
                                        />
                                        <RadiosEditor
                                            cssWrapper="control-size-430 mb-16"
                                            label="Granted"
                                            selected={this.grantSelected(e.key)}
                                            options={GrantedTypes}
                                            getText={(v) => GrantedTypesMap[v]}
                                            onChange={(v) => {
                                                GrantedTypes.forEach((t) => {
                                                    t == v
                                                        ? (PensionProtection[e.key][t] = true)
                                                        : (PensionProtection[e.key][t] = false);
                                                });
                                                this.setState({ PensionProtection });
                                            }}
                                            required="Please select Granted"
                                        />
                                    </>
                                );
                                break;
                            case "PensionSchemeSpecificProtectionDetails":
                                child = (
                                    <>
                                        <NumberTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Protected PCLS value"
                                            validationRules={[
                                                {
                                                    errorMessage: "Please enter Protected PCLS value",
                                                    validator: (v) => {
                                                        return (
                                                            !_data[e.key].ADayFundValue || _data[e.key].PclsEntitlement
                                                        );
                                                    },
                                                },
                                            ]}
                                            maxLength={15}
                                            value={_data[e.key].PclsEntitlement}
                                            onChange={(v) => {
                                                this.dataOnchanged(e.key, v, "PclsEntitlement");
                                            }}
                                            onBlur={(v) => {
                                                this.dataOnchanged(
                                                    e.key,
                                                    Number(CommonHelper.downFixed(v, 2)),
                                                    "PclsEntitlement"
                                                );
                                            }}
                                        />
                                        <NumberTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="ADay fund value"
                                            validationRules={[
                                                {
                                                    errorMessage: "Please enter ADay fund value",
                                                    validator: (v) => {
                                                        return (
                                                            !_data[e.key].PclsEntitlement || _data[e.key].ADayFundValue
                                                        );
                                                    },
                                                },
                                            ]}
                                            maxLength={15}
                                            value={_data[e.key].ADayFundValue}
                                            onChange={(v) => {
                                                this.dataOnchanged(e.key, v, "ADayFundValue");
                                            }}
                                            onBlur={(v) => {
                                                this.dataOnchanged(
                                                    e.key,
                                                    Number(CommonHelper.downFixed(v, 2)),
                                                    "ADayFundValue"
                                                );
                                            }}
                                        />
                                        <NumberTextBoxEditor
                                            cssWrapper="control-size-430"
                                            label="Protected retirement age"
                                            required={
                                                !_data[e.key].PclsEntitlement && !_data[e.key].ADayFundValue
                                                    ? "Please enter Protected retirement age"
                                                    : null
                                            }
                                            atMost={{
                                                errorMessage: "A value between 35 and 54 is expected.",
                                                value: 54,
                                            }}
                                            atLeast={{
                                                errorMessage: "A value between 35 and 54 is expected.",
                                                value: 35,
                                            }}
                                            value={_data[e.key].ProtectedRetirementAge}
                                            onChange={(v) => {
                                                this.dataOnchanged(e.key, v, "ProtectedRetirementAge");
                                            }}
                                        />
                                    </>
                                );
                            default:
                                break;
                        }
                    }
                    return (
                        <>
                            <RadiosEditor
                                label={e.value}
                                selected={PensionProtection[e.key] != null}
                                onChange={(v) => {
                                    if (v) {
                                        if (_data[e.key] == null) {_data[e.key] = {};}
                                        PensionProtection[e.key] = _data[e.key];
                                        if (e.key == "PensionFixedProtectionDetails") {
                                            PensionProtection.PensionFixed2014ProtectionDetails = null;
                                            PensionProtection.PensionFixed2016ProtectionDetails = null;
                                            PensionProtection.PensionEnhancedProtectionDetails = null;
                                            PensionProtection.PensionPrimaryProtectionDetails = null;
                                        }
                                        if (e.key == "PensionFixed2014ProtectionDetails") {
                                            PensionProtection.PensionFixedProtectionDetails = null;
                                            PensionProtection.PensionFixed2016ProtectionDetails = null;
                                            PensionProtection.PensionEnhancedProtectionDetails = null;
                                            PensionProtection.PensionPrimaryProtectionDetails = null;
                                        }
                                        if (e.key == "PensionFixed2016ProtectionDetails") {
                                            PensionProtection.PensionFixed2014ProtectionDetails = null;
                                            PensionProtection.PensionFixedProtectionDetails = null;
                                            PensionProtection.PensionEnhancedProtectionDetails = null;
                                            PensionProtection.PensionPrimaryProtectionDetails = null;
                                        }
                                        if (e.key == "PensionIndividual2014ProtectionDetails") {
                                            PensionProtection.PensionIndividual2016ProtectionDetails = null;
                                            PensionProtection.PensionPrimaryProtectionDetails = null;
                                        }
                                        if (e.key == "PensionIndividual2016ProtectionDetails") {
                                            PensionProtection.PensionIndividual2014ProtectionDetails = null;
                                            PensionProtection.PensionPrimaryProtectionDetails = null;
                                        }
                                    } else {
                                        PensionProtection[e.key] = null;
                                    }
                                    this.setState({ PensionProtection });
                                }}
                                disabled={this.redioDisable(e.key)}
                                required={"Please select " + e.value}
                                {...radioOptions}
                            />
                            {child}
                        </>
                    );
                })}
                <div className="col-12 col-sm-4 pl-0 pb-20">
                    <button className="btn primary label-offset" onClick={() => this.onSave()}>
                        Save
                    </button>
                </div>
            </div>
        );
    }
}
